// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603181045/js/" + chunkId + "." + {"44":"b774e472","225":"ae613546","481":"c9b11995","486":"b1333e7c","770":"169f9b25"}[chunkId] + ".0.22506699774860617.chunk.js";
};